module.exports = __webpack_public_path__ + "static/media/staff3.be3a4829.png";